export const reportDict = {
    0: "Income Statement",
    1: "Balance Sheet",
    // 2: "Cash Flows",
    2: "Income Statement Transactions",
    3: "Balance Sheet Transactions",
  };